// @ts-nocheck
import React from 'react';
import Navbar from 'components/Navbar';
import AdBanner from 'components/AdBanner';
import { StakeDataContextProvider } from './StakeContext/StakeDataContext';
import StakePageContent from './StakePageContent';
import { StakeTxContextProvider } from './StakeContext/StakeTxContext';

const StakePage = () => {
  return (
    <StakeDataContextProvider>
      <StakeTxContextProvider>
        <Navbar />
        <AdBanner />
        <StakePageContent />
      </StakeTxContextProvider>
    </StakeDataContextProvider>
  );
};

export default StakePage;
